export enum Roles {
  USER = 'User',
  ADMIN = 'Admin',
  ACM = 'AdultCommunityMember',
  ACCOUNT_ADMIN = 'AcctAdmin',
  ZONE_ADMIN = 'ZoneAdmin',
  SUPER_ADMIN = 'SuperAdmin',
  COACH = 'Coach',
  JEM = 'JEM',
  YOUTH_RIDER = 'YouthRider',
  ADULT_RIDER = 'AdultRider',
  SHOW_OFFICIAL = 'ShowOfficial',
  SPECTATOR = 'Spectator',
}
